import { render } from "./TrainingContactBlockListComponent.vue?vue&type=template&id=fc0e0254&scoped=true"
import script from "./TrainingContactBlockListComponent.vue?vue&type=script&lang=js"
export * from "./TrainingContactBlockListComponent.vue?vue&type=script&lang=js"

import "./TrainingContactBlockListComponent.vue?vue&type=style&index=0&id=fc0e0254&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc0e0254"]])

export default __exports__